/* Magtion — custom photo uploader (client)
   3 slots max, uploads to uploads.magtion.com, writes properties[Photo N] on the product form. */
(function () {
  'use strict';

  var MAX_BYTES = 20 * 1024 * 1024;
  var OK_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/heic', 'image/heif'];

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function skey(handle) { return 'cpu:v1:' + handle; }
  function loadState(handle) {
    try { return JSON.parse(sessionStorage.getItem(skey(handle)) || '{}') || {}; } catch (e) { return {}; }
  }
  function saveState(handle, st) {
    try { sessionStorage.setItem(skey(handle), JSON.stringify(st)); } catch (e) { /* private mode */ }
  }

  function findForm() {
    return $('form[data-type="add-to-cart-form"]') || $('form[id^="product-form-"]');
  }

  /* 店里还装着 Cloudlift（Live Product Options）。只有当它在这个商品上
     真的渲染了文件上传字段时，我们才收起来；它只配了文字字段（比如 Name 1..5）
     而没有任何上传入口时，我们继续显示，避免商品完全没法传图。 */
  function cloudliftActive() {
    if (!$('input[name="properties[_cl_options]"]')) return false;
    return $$('input[type=file]').some(function (el) {
      return ('' + el.className).indexOf('cpu') === -1;
    });
  }

  function init(root) {
    if (root.dataset.cpuInit === '1') return;
    root.dataset.cpuInit = '1';

    var handle = root.dataset.product || 'unknown';
    var endpoint = (root.dataset.endpoint || 'https://uploads.magtion.com').replace(/\/+$/, '');
    var slots = parseInt(root.dataset.slots || '3', 10);
    var state = loadState(handle);
    var msg = $('[data-cpu-msg]', root);

    function setMsg(text, kind) {
      if (!msg) return;
      msg.textContent = text || '';
      msg.hidden = !text;
      msg.dataset.kind = kind || 'error';
    }

    function slotEl(i) { return $('[data-slot="' + i + '"]', root); }

    function setState(i, st) {
      var el = slotEl(i);
      if (el) {
        if (st) el.dataset.state = st; else delete el.dataset.state;
      }
    }

    /* 把已上传的 URL 写进商品表单（Dawn 用 FormData 提交，隐藏 input 会自动带上） */
    function syncProperties() {
      var form = findForm();
      if (!form) return;
      for (var i = 1; i <= slots; i++) {
        var existing = $$('input[data-cpu-prop]', form).filter(function (el) {
          return el.getAttribute('data-cpu-prop') === String(i);
        })[0];
        var url = state[i];
        if (url) {
          if (!existing) {
            existing = document.createElement('input');
            existing.type = 'hidden';
            existing.setAttribute('data-cpu-prop', String(i));
            existing.name = 'properties[Photo ' + i + ']';
            form.appendChild(existing);
          }
          if (existing.value !== url) existing.value = url;
        } else if (existing) {
          existing.parentNode.removeChild(existing);
        }
      }
    }

    function isReady() { return !!state[1]; }

    /* 比例预览：读当前选中变体的尺寸，把照片按那个比例裁一遍 */
    var variants = [];
    try {
      var vEl = $('[data-cpu-variants]', root);
      if (vEl) variants = JSON.parse(vEl.textContent || '[]');
    } catch (e) { variants = []; }

    function currentVariantId() {
      var i = $('input.product-variant-id');
      return i ? String(i.value) : '';
    }
    function variantTitle(id) {
      for (var k = 0; k < variants.length; k++) {
        if (String(variants[k].id) === id) return variants[k].title || '';
      }
      return '';
    }
    function sizeRatio(title) {
      var m = title && title.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i);
      if (!m) return null;
      return parseFloat(m[2]) / parseFloat(m[1]);
    }
    function updatePreview() {
      var box = $('[data-cpu-preview]', root);
      if (!box) return;
      var url = state[1];
      if (!url) { box.hidden = true; return; }
      var title = variantTitle(currentVariantId());
      var r = sizeRatio(title);
      var img = $('[data-cpu-preview-img]', box);
      var lab = $('[data-cpu-size]', box);
      box.hidden = false;
      if (img && img.getAttribute('src') !== url) img.src = url;
      if (lab) lab.textContent = title ? title.replace(/\s*in\b/i, '″') : 'the size you choose';
      if (img) img.style.aspectRatio = r ? ('1 / ' + r.toFixed(4)) : '1 / 1.5';
    }

    function paint(i) {
      var el = slotEl(i);
      if (!el) return;
      var img = $('.cpu-thumb', el);
      var empty = $('.cpu-empty', el);
      var check = $('.cpu-check', el);
      var remove = $('.cpu-remove', el);
      var url = state[i];
      if (url) {
        if (img) { img.src = url; img.hidden = false; }
        if (empty) empty.hidden = true;
        if (check) check.hidden = false;
        if (remove) remove.hidden = false;
        setState(i, 'done');
      } else {
        if (img) { img.hidden = true; img.removeAttribute('src'); }
        if (empty) empty.hidden = false;
        if (check) check.hidden = true;
        if (remove) remove.hidden = true;
        setState(i, '');
      }
      updatePreview();
    }

    function progress(i, pct) {
      var el = slotEl(i);
      if (!el) return;
      var bar = $('.cpu-bar > span', el);
      if (bar) bar.style.width = Math.max(2, Math.round(pct * 100)) + '%';
    }

    function upload(i, file) {
      var el = slotEl(i);
      setState(i, 'uploading');
      setMsg('');
      progress(i, 0);

      var fd = new FormData();
      fd.append('file', file, file.name || ('photo' + i + '.jpg'));
      fd.append('product', handle);
      fd.append('slot', String(i));

      var xhr = new XMLHttpRequest();
      xhr.open('POST', endpoint + '/upload', true);
      xhr.timeout = 120000;
      xhr.upload.onprogress = function (e) {
        if (e.lengthComputable) progress(i, (e.loaded / e.total) * 0.9);
      };
      xhr.onload = function () {
        progress(i, 1);
        var data = null;
        try { data = JSON.parse(xhr.responseText); } catch (e) { data = null; }
        if (xhr.status >= 200 && xhr.status < 300 && data && data.url) {
          state[i] = data.url;
          saveState(handle, state);
          paint(i);
          syncProperties();
          setMsg('Photo ' + i + ' uploaded. ' + (isReady() ? 'You can add it to your cart now.' : ''), 'ok');
          if (i === 1 && slots > 1) {
            var next = $('.cpu-input', slotEl(2));
            if (next) next.focus({ preventScroll: true });
          }
        } else {
          setState(i, 'error');
          var text = (data && (data.detail || data.message)) || 'Upload failed. Please try again.';
          setMsg(typeof text === 'string' ? text : 'Upload failed. Please try again.', 'error');
        }
      };
      xhr.onerror = xhr.ontimeout = function () {
        setState(i, 'error');
        setMsg('Network problem — please check your connection and try again.', 'error');
      };
      xhr.send(fd);
    }

    function onPick(i, input) {
      var file = input.files && input.files[0];
      if (!file) return;
      var name = (file.name || '').toLowerCase();
      var typeOk = OK_TYPES.indexOf(file.type) >= 0 || /\.(jpe?g|png|webp|heic|heif)$/.test(name);
      if (!typeOk) {
        setMsg('That file type is not supported. Please use a JPG, PNG or HEIC photo.', 'error');
        input.value = '';
        return;
      }
      if (file.size > MAX_BYTES) {
        setMsg('That photo is ' + (file.size / 1048576).toFixed(1) + 'MB. The limit is 20MB — please choose a smaller one.', 'error');
        input.value = '';
        return;
      }
      // 本地预览立即出现，不等上传完成
      var el = slotEl(i);
      var img = el && $('.cpu-thumb', el);
      var empty = el && $('.cpu-empty', el);
      var tmp = URL.createObjectURL(file);
      if (img) { img.src = tmp; img.hidden = false; }
      if (empty) empty.hidden = true;
      upload(i, file);
      input.value = '';
    }

    for (var i = 1; i <= slots; i++) {
      (function (idx) {
        var el = slotEl(idx);
        if (!el) return;
        var input = $('.cpu-input', el);
        if (input) input.addEventListener('change', function () { onPick(idx, input); });
        var remove = $('.cpu-remove', el);
        if (remove) remove.addEventListener('click', function (ev) {
          ev.preventDefault();
          delete state[idx];
          saveState(handle, state);
          paint(idx);
          syncProperties();
        });
      })(i);
      paint(i);
    }
    syncProperties();

    /* 必填校验：拦截表单提交（含 Shop Pay 动态结账），在 Dawn 的 fetch 之前触发 */
    if (!root.dataset.cpuGuard) {
      root.dataset.cpuGuard = '1';
      document.addEventListener('submit', function (ev) {
        var form = ev.target;
        if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;
        if (form.getAttribute('data-cpu-product') && form.getAttribute('data-cpu-product') !== handle) return;
        if (isReady()) return;
        ev.preventDefault();
        ev.stopImmediatePropagation();
        root.dataset.requiredMissing = 'true';
        setMsg('Please upload Photo 1 first — we cannot print this order without it.', 'error');
        try {
          root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } catch (e) { root.scrollIntoView(); }
        window.setTimeout(function () { root.dataset.requiredMissing = 'false'; }, 1200);
      }, true);
    }

    /* 尺寸切换：预览比例跟着变（Dawn 用隐藏 input 存变体 id，不一定触发 change） */
    var lastVid = currentVariantId();
    window.setInterval(function () {
      var v = currentVariantId();
      if (v !== lastVid) { lastVid = v; syncProperties(); updatePreview(); }
    }, 800);

    /* 变体切换 / 区块重渲染后，把 state 里的属性补回新表单 */
    var mo = new MutationObserver(function () { syncProperties(); });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  function boot() {
    var roots = $$('[data-cpu]');
    if (!roots.length) return;
    var form = findForm();
    if (form && roots[0].dataset.product) form.setAttribute('data-cpu-product', roots[0].dataset.product);
    roots.forEach(init);

    /* Cloudlift 是异步注入的：它出现就把我们的收起来，它消失再放回来 */
    function syncCloudlift() {
      var cl = cloudliftActive();
      roots.forEach(function (root) {
        root.hidden = cl;
        root.dataset.cpuShadowed = cl ? '1' : '0';
      });
    }
    syncCloudlift();
    var moCL = new MutationObserver(syncCloudlift);
    moCL.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
